<template>
    <tg-layout>
        <template slot="header">
            <el-row type="flex" justify="space-between">
                <tg-search-tool @on-submit="handleSearch">
                    <tg-dropdown
                        :items="dropdown"
                        @on-change="handleChange"
                        trigger="click"
                    >
                        <template slot="icon"></template>
                    </tg-dropdown>
                    <tg-date-search
                        ref="dateSearch"
                        size="small"
                        v-model="dateRange"
                    ></tg-date-search>
                    <el-input
                        :placeholder="
                            $t('component.form.input.placeholder.member')
                        "
                        v-model="searchData.search_name"
                        class="tg-input"
                        size="small"
                        style="width: 220px"
                        clearable
                    ></el-input>
                    <template slot="right"></template>
                </tg-search-tool>
                <el-row type="flex" justify="start" align="middle">
                    <div
                        style="
                            font-family: SourceHanSansCN;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.33;
                            letter-spacing: 0.6px;
                            text-align: right;
                        "
                    >
                        <label
                            >{{
                                $t("component.label.activity.member_of_join")
                            }}:</label
                        >
                        <label style="color: #1168a8">{{
                            total_of_member
                        }}</label>
                    </div>
                    <div
                        style="
                            font-family: SourceHanSansCN;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.33;
                            letter-spacing: 0.6px;
                            text-align: right;
                            padding: 0 8px;
                        "
                    >
                        <label
                            >{{
                                $t("component.label.activity.apply_amount")
                            }}:</label
                        >
                        <label style="color: #1168a8">{{
                            total_of_apply_amount
                        }}</label>
                    </div>
                    <tg-button
                        round
                        border
                        hoverBorderOnly
                        theme="info"
                        @click.native="handleExport"
                        v-show="hasData"
                    >
                        <template slot="icon" slot-scope="scope">
                            <i
                                class="tg-icon tg-icon-export"
                                :class="{ active: scope.isHover }"
                            ></i>
                        </template>
                        {{ $t("component.btn.exportCSV") }}
                    </tg-button>
                </el-row>
            </el-row>
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            showPagination
            @on-loaded="handleLoaded"
        >
            <template slot="userfullname" slot-scope="scope">
                <tg-user-full-name
                    :row="scope.row"
                    :column="scope.column"
                ></tg-user-full-name>
            </template>

            <!-- 申請項目 -->
            <template slot="apply_item" slot-scope="scope">
                <span v-if="scope.row.apply_item">
                    {{scope.row.apply_item}}
                </span>
                <span v-else>
                    申请项目显示异常
                </span>
            </template>

            <template slot="note" slot-scope="scope">
                <span>{{ scope.row.note1 }}</span>
                <br v-if="scope.row.nonte1 != '-'" />
                <span v-if="scope.row.nonte1 != '-'">{{
                    scope.row.note2
                }}</span>
            </template>
        </tg-table>
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";
import apis from "@/apis";
import { convertToRows, flatColumns } from "@/utils/table";
import str from "@/utils/str";
import xlsx from "@/utils/xlsx";
const api = apis.activity.detail;

export default {
    components: {
        TgLayout,
        TgDateSearch,
        TgUserFullName,
        TgTable,
        TgSearchTool,
        TgDropdown,
        TgButton,
    },
    data() {
        return {
            proxy: api.getData,
            dateRange: {},
            columns: [],
            dropdown: [], //存放活動類別之下拉選單
            total_of_member: 0,
            total_of_apply_amount: 0,
            searchData: {
                activity_id: "", //查詢時的活動類別id
                target_name: "", //進入時的通路商帳號
                search_name: "", //查詢的會員帳號
                status: "", //查詢的活動狀態
            },
            isInit: true,
            hasData: false,
        };
    },
    props: {
        hasUser: Boolean,
    },
    created() {
        if (this.$route.params.username) {
            this.$router.push({ name: "activity.detail.index" });
        }

        let dropdown = ["All", 0, 1, 2, 8].map((item) => {
            let key = item == 'All' ? "component.dropdown.activity.All" : "component.dropdown.activity[" + item + "]";
            return {
                name: this.$t(key),
                id: item,
            };
        });

        this.dropdown = this.parseDropdown(dropdown);
        this.searchData.activity_id = this.$route.params.activity_id;
        this.searchData.target_name = this.$route.params.target_name;
        if (this.$route.params.search_name != null) {
            this.searchData.search_name = this.$route.params.search_name;
        }
        this.searchData.status = "All";
        this.searchData.isInit = this.isInit;

        api.getColumns().then((response) => {
            this.columns = response.data.columns;
            this.$nextTick(() => {
                this.$refs.table.init(this.request);
            });
        });
    },
    computed: {
        dateString() {
            return this.dateRange.startDate + "-To-" + this.dateRange.endDate;
        },
        //按下【查詢】時將時間和其他查詢資料合併送出
        request() {
            return { ...this.searchData, ...this.dateRange };
        },
    },
    methods: {
        handleLoaded(response) {
            if(response.retcode == 0){
                this.hasData = response.data.length > 0;
                if (this.isInit) {
                    this.dateRange.startDate = response.start_date;
                    this.dateRange.endDate = response.end_date;
                    this.isInit = false;
                    this.searchData.isInit = this.isInit;
                }
                //處理右上角的 會員參加人數 核發點數
                this.total_of_member = response.total_of_member;
                this.total_of_apply_amount = response.total_of_apply_amount;

                //處理麵包屑
                this.$store.commit("breadcrumb/clear");
                this.$store.commit("breadcrumb/add", {
                    id: "activity.agent.activity_" + response.activity_name,
                    name: "activity.agent.activity_name",
                    query: {
                        ...this.$route.query,
                    },
                    params: this.$route.params,
                    meta: {
                        title: response.activity_name,
                        disable: true,
                    },
                });

                let title = str.format(
                    "{0} ({1})",
                    this.$t("column.l" + this.$user.group),
                    this.$user.username
                );

                // this.$store.commit("breadcrumb/add", {
                //     id: "activity.agent.user_" + this.$user.username,
                //     name: "activity.agent.user",
                //     query: {
                //         ...this.$route.query,
                //     },
                //     meta: {
                //         title: title,
                //         disable: true,
                //     },
                // });

                title = str.format(
                    "{0} ({1})",
                    this.$t("column.l" + response.target_group),
                    response.target_name
                );

                this.$store.commit("breadcrumb/add", {
                    id: "activity.agent.user_" + response.target_name,
                    name: "activity.agent.user",
                    query: {
                        ...this.$route.query,
                    },
                    params: {
                        target_name: response.target_name,
                    },
                    meta: {
                        title: title,
                        disable: true,
                    },
                });
            }
        },
        handleSearch() {
            this.$refs.table.search(this.request);
        },
        handleChange(item) {
            //變更篩選類別項目
            this.selected = item;
            this.searchData.status = item.value;
        },
        handleExport() {
            let normalColumns = JSON.parse(JSON.stringify(this.columns));

            normalColumns[1].xlsx = {
                ...normalColumns[1].xlsx,
                component: TgUserFullName,
            };
            normalColumns[6].width = 250;

            let headerRow = convertToRows(normalColumns);
            let columns = flatColumns(normalColumns);

            if (this.hasData) {
                let request = { ...this.request, isExport: true };
                if (this.$route.params.username) {
                    request.targetName = this.$route.params.username;
                }
                this.proxy(request).then((response) => {
                    let data = response.data;
                    let ws = xlsx.makeSheet(headerRow, columns, data);
                    xlsx.exportExcel(
                        ws,
                        "活动申请记录-" +
                            new Date().toISOString().replace(/[-:.]/g, "")
                    );
                });
            } else {
                //使用compiledData 取得已篩選的資料
                let table = this.$refs.table.$refs.ElTable;
                let data = table.store.states.filteredData;
                let ws = xlsx.makeSheet(headerRow, columns, data);
                xlsx.exportExcel(
                    ws,
                    "活动申请记录-" +
                        new Date().toISOString().replace(/[-:.]/g, "")
                );
            }
        },
        parseDropdown(dropdown) {
            return dropdown.map((item) => {
                return {
                    label: item.name,
                    value: item.id,
                };
            });
        },
    },
};
</script>
